import { helpContact, pageBlockId } from "../../../../constants/pageBlocks";
import { IStudentHelp } from "../../../../models/student/studentCourceDetail";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { setDescriptionText } from "../../../../store/slices/common/commonSlice";
import { getDescriptionText } from "../../../../action/common/commonActionCreator";
import ReactModal from "react-modal";
import StudentHelpModal from "./studentHelpModal";
import { getStudentInfoDetails } from "../../../../action/student/studentInfoActionCreator";
import { setStudentInfo } from "../../../../store/slices/student/studentInfoSlice";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";
import { baseURL } from "../../../../constants/commonConstants";

const StudentHelp = (props: IStudentHelp) => {
  const {
    userInfo,
    getDescriptionText,
    description,
    getStudentInfo,
    studentInfo,
    snapShots,
  } = props;

  const dispatch = useDispatch();
  const [showCompose, setShowCompose] = useState<boolean>(false);
  const [selectedContact, setSelectedContact] = useState<number>(0);
  const pageBlockData = getPageBlockData(snapShots, pageBlockId.help);

  const handleOpenModal = () => setShowCompose(true);
  const handleCloseModal = () => setShowCompose(false);

  useEffect(() => {
    getDescriptionText(pageBlockId.help);
    getStudentInfo(userInfo?.id);
  }, [userInfo, pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setDescriptionText([]));
      dispatch(setStudentInfo([]));
    };
  }, []);

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedContact(Number(event.target.value));
  };

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot
            ? "card-wrap d-flex align-items-center emailbot"
            : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        {pageBlockData?.displayOrNot && (
          <>
            <h2>Need Help? Contact Us Here</h2>
            {description?.description && <p>{description.description}</p>}
            <div className="d-flex align-items-center flex-column gap-2 mt-3 w-100">
              <div className="form-group mb-2 w-100">
                <select name="" id="" className="w-100" onChange={onChange}>
                  <option disabled selected>
                    Select Contacts
                  </option>
                  <option value={helpContact.advisor}>Contact Advisor</option>
                  <option value={helpContact.faculty}>Contact Faculty</option>
                  <option value={helpContact.contactSuccessStudent}>
                    Contact Student Success
                  </option>
                </select>
              </div>
              <button
                className="btn btn-primary w-100"
                onClick={() => handleOpenModal()}
                disabled={selectedContact ? false : true}
              >
                Connect
              </button>
            </div>
          </>
        )}
      </div>
      <ReactModal
        isOpen={showCompose}
        onRequestClose={handleCloseModal}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <StudentHelpModal
          setShowCompose={handleCloseModal}
          selectedContact={selectedContact}
        />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getDescriptionText: (pageBlockId: number) => getDescriptionText(pageBlockId),
  getStudentInfo: (id: string) => getStudentInfoDetails(id),
};

function mapStateToProps(state: any) {
  return {
    description: state.common.descriptionText,
    studentInfo: state.studentInfo.studentInfo,
    userInfo: state.userDetails.userProfileData,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentHelp);
